import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';


export const inciddentAlert = createAction(types.ALERT_DATA, (incident:any[]) => ({
    payload: incident,
}));
